const OPENABLE_PROTOCOLS = ['http:', 'https:', 'mailto:', 'tel:'];

// The URL of an Action.OpenUrl comes from whoever designed the form, and the form is shown to
// requesters too, so only open schemes that cannot run script in the app's window.
export const cardUrlToOpen = (url: string): string | null => {
  const trimmed = url?.trim();
  if (!trimmed) return null;

  let parsed: URL;
  try {
    parsed = new URL(trimmed);
  } catch {
    try {
      parsed = new URL(`https://${trimmed}`);
    } catch {
      return null;
    }
  }

  return OPENABLE_PROTOCOLS.includes(parsed.protocol) ? parsed.href : null;
};
